import { useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ListStatus from "./ListStatus";
import DragItem from "./DragItem";

const DragList = ({ 
    listData, 
    listAttr = "name",
    listTitle,
    emptyText,
    disabled = false, 
    drag = {}
}) => {

    const renderList = useMemo(() => (
        <ul className="list-group">
            {listData.map((element, index) => <DragItem 
                key={index}
                index={index}
                label={element[listAttr]}
                type={drag.type}
                disabled={disabled}
                onReorder={drag.onReorder}
            />)}
        </ul>
    ), [listData, listAttr, drag, disabled]);

    return <>
        <label className="form-label h6">{listTitle}</label>
        { listData && listData.length > 0 ? 
            <DndProvider backend={HTML5Backend}>{renderList}</DndProvider> :
            <ListStatus loading={false} error={false} empty={true} emptyText={emptyText} ></ListStatus>}
    </>;
};

export default DragList;